import { useEffect, useContext } from 'react'
import { isAndroid, isIOS } from 'react-device-detect'
import { useHistory, useLocation } from 'react-router-dom'
import { observer } from 'mobx-react-lite'

import rootStoreContext from '../../../../store.context'

export const AppBridge = observer(() => {
	const history = useHistory()
	const { search } = useLocation()

	const rootStore = useContext(rootStoreContext)

	const redirect = () => {
		let resolved = false
		if (
			!resolved
			&& search.includes(`android`)
			&& rootStore.laboratory.stringFlags.get(`androidStoreAppUrl`)
		) {
			resolved = true
			window.location.href = rootStore.laboratory.stringFlags.get(`androidStoreAppUrl`)!
		}
		if (
			!resolved
			&& search.includes(`ios`)
			&& rootStore.laboratory.stringFlags.get(`iosStoreAppUrl`)
		) {
			resolved = true
			window.location.href = rootStore.laboratory.stringFlags.get(`iosStoreAppUrl`)!
		}

		if (
			!resolved
			&& isAndroid
			&& rootStore.laboratory.stringFlags.get(`androidStoreAppUrl`)
		) {
			resolved = true
			window.location.href = rootStore.laboratory.stringFlags.get(`androidStoreAppUrl`)!
		}

		if (
			!resolved
			&& isIOS
			&& rootStore.laboratory.stringFlags.get(`iosStoreAppUrl`)
		) {
			resolved = true
			window.location.href = rootStore.laboratory.stringFlags.get(`iosStoreAppUrl`)!
		}

		if (!resolved) history.replace(`/`)
	}

	useEffect(() => {
		redirect()
	}, []) // eslint-disable-line

	return null
})